import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  TextField,
} from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const PrintSettings = ({
  settings,
  onSettingsChange,
  id,
  onCopy,
  onRemove,
}) => {
  const [textList, setTextList] = useState(
    settings.map((s) => s.textfield ?? ''),
  );
  const handleTextChange = (index, value) => {
    setTextList((prev) => {
      const updated = [...prev];
      updated[index] = value;
      return updated;
    }); //onSettingsChange({ ...settings, textfield: value });
  };

  const handleTextCommit = (index) => {
    const next = [...settings];
    const value = { ...next[index], textfield: textList[index] };
    next[index] = value;

    onSettingsChange(id, index, next);
  };

  const handlePrintFlagsChange = (index, key, bool) => {
    const next = [...settings];
    const value = {
      ...next[index],
      printFlags: { ...next[index].printFlags, [key]: bool },
    };
    next[index] = value;

    onSettingsChange(id, index, next);
  };

  const { t } = useTranslation('print');

  return (
    <Box
      mb={2}
      flexDirection={'column'}
      justifyContent={'flex-end'}
      display={'flex'}
      gap={1}
    >
      {settings.map((s, index) => {
        return (
          <Box key={index} flexDirection={'column'} display={'flex'} gap={1}>
            {index !== 0 && <Divider sx={{ my: 2 }} />}
            <TextField
              multiline
              label={t('description')}
              value={textList[index]}
              onChange={(e) => handleTextChange(index, e.target.value)}
              fullWidth
              variant="outlined"
            />
            {s.printFlags &&
              Object.keys(s.printFlags).map((key, idx) => (
                <Box key={idx} ml={1}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={s.printFlags[key]}
                        onChange={(e) =>
                          handlePrintFlagsChange(index, key, e.target.checked)
                        }
                      />
                    }
                    label={t(`print_flags.${key}`)}
                  />
                </Box>
              ))}

            <Box justifyContent={'flex-end'} display={'flex'}>
              <Button
                disabled={s.textfield === (textList[index] ?? '')}
                onClick={() => handleTextCommit(index)}
                variant="contained"
              >
                {t('buttons.save')}
              </Button>
              {index !== 0 && (
                <Button
                  sx={{ ml: 1 }}
                  variant="outlined"
                  color="error"
                  onClick={() => onRemove(id, index)}
                >
                  {t('buttons.remove')}
                </Button>
              )}
            </Box>
          </Box>
        );
      })}
      <Divider />
      <Button onClick={() => onCopy(id)}> {t('buttons.add')}</Button>
    </Box>
  );
};

export default PrintSettings;
